var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_uid.js
// module id = 94
// module chunks = 168707334958949